export default function Marquee() {
  const phrase = "TRUST NOBODY · EVERY STORY STARTS BROKEN · UK ROLEPLAY · BROKEN RP · THE ENDS · ";
  const items = new Array(6).fill(phrase);
  return (
    <section
      data-testid="marquee"
      className="relative py-10 md:py-14 border-y border-white/5 bg-black/40 overflow-hidden"
    >
      <div className="marquee-track font-display text-white tracking-tighter text-[14vw] md:text-[9vw] leading-none">
        {items.map((t, i) => (
          <span key={i} className={i % 2 === 1 ? "text-[color:var(--accent-red)]" : ""}>
            {t}
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[color:var(--bg-base)] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[color:var(--bg-base)] to-transparent" />
    </section>
  );
}
